"use client";

import styled from "styled-components";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Black, White } from "@/styles/globalStyleVars";
import ThemeRow from "@/components/theme/row";
import reactHtmlParser from "react-html-parser";

const BannerAddress = ({ data }) => {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const offsetFunk = () => {
      setOffset(document.querySelector(".footer .container").offsetLeft + 15);
    };
    window.addEventListener("resize", () => {
      offsetFunk();
    });
    offsetFunk();
  }, [data]);
  return (
    <StyledBannerAddress className={"banner-address"} offset={offset}>
      <ThemeRow fluid rowClass={"banner-address-wrapper"}>
        {data?.address && (
          <div className={"address"}>
            <img src="/images/static/loc.svg" alt="Location" />
            <a href={data?.map_link} target={"_blank"}>
              {reactHtmlParser(data?.address)}
            </a>
          </div>
        )}

        {data?.phone && (
          <div className={"phone"}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="Rectangle_6950"
                    data-name="Rectangle 6950"
                    width="20"
                    height="20"
                    transform="translate(798 4283)"
                    fill="#fff"
                    stroke="#707070"
                    strokeWidth="1"
                  />
                </clipPath>
              </defs>
              <g
                id="Mask_Group_19930"
                data-name="Mask Group 19930"
                transform="translate(-798 -4283)"
                clip-path="url(#clip-path)"
              >
                <g
                  id="Group_25463"
                  data-name="Group 25463"
                  transform="translate(799.09 4284.375)"
                >
                  <path
                    id="Path_10809"
                    data-name="Path 10809"
                    d="M15.148,12.006c-1.042-.891-2.1-1.431-3.129-.541L11.4,12c-.45.39-1.286,2.215-4.518-1.5S5.577,6.207,6.028,5.82l.618-.539c1.024-.892.638-2.015-.1-3.171L6.1,1.41C5.357.257,4.549-.5,3.523.39L2.968.875A5.207,5.207,0,0,0,.939,4.321c-.37,2.449.8,5.254,3.474,8.331s5.289,4.625,7.768,4.6a5.221,5.221,0,0,0,3.693-1.529l.557-.485c1.024-.89.388-1.8-.655-2.689Z"
                    transform="translate(0)"
                    fill="#e62e43"
                  />
                </g>
              </g>
            </svg>
            <a href={`tel:${data?.phone}`}>{reactHtmlParser(data?.phone)}</a>
          </div>
        )}

        {data?.email && (
          <div className={"email"}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="Rectangle_6973"
                    data-name="Rectangle 6973"
                    width="20"
                    height="20"
                    transform="translate(798 4283)"
                    fill="#fff"
                    stroke="#707070"
                    strokeWidth="1"
                  />
                </clipPath>
              </defs>
              <g
                id="Mask_Group_19971"
                data-name="Mask Group 19971"
                transform="translate(-798 -4283)"
                clip-path="url(#clip-path)"
              >
                <g
                  id="Group_25464"
                  data-name="Group 25464"
                  transform="translate(799.11 4222.076)"
                >
                  <path
                    id="Path_10811"
                    data-name="Path 10811"
                    d="M10.376,176.343a2.674,2.674,0,0,1-2.972,0L.118,171.486q-.061-.04-.118-.084v7.959A1.636,1.636,0,0,0,1.637,181H16.144a1.636,1.636,0,0,0,1.637-1.637V171.4c-.039.029-.078.057-.119.084Z"
                    transform="translate(0 -103.415)"
                    fill="#e62e43"
                  />
                  <path
                    id="Path_10812"
                    data-name="Path 10812"
                    d="M.7,67.2l7.286,4.857a1.633,1.633,0,0,0,1.816,0L17.084,67.2a1.56,1.56,0,0,0,.7-1.3,1.638,1.638,0,0,0-1.636-1.636H1.636A1.638,1.638,0,0,0,0,65.9a1.56,1.56,0,0,0,.7,1.3Z"
                    transform="translate(0)"
                    fill="#e62e43"
                  />
                </g>
              </g>
            </svg>
            <a href={`mailto:${data?.email}`}>{reactHtmlParser(data?.email)}</a>
          </div>
        )}
      </ThemeRow>
    </StyledBannerAddress>
  );
};

const StyledBannerAddress = styled.div`
  margin-left: ${(p) => p.offset + "px"};
  margin-top: -46px;
  z-index: 99999999;
  position: relative;
  background: #ffffff;

  .banner-address-wrapper {
    padding: 30px 100px;
    background-color: ${Black};
    display: flex;
    gap: 70px;

    .address,
    .phone,
    .email {
      display: flex;
      gap: 20px;
      align-items: flex-start;

      a {
        color: ${White};
      }
    }

    .address {
      width: 25%;
    }

    @media (max-width: 767px) {
      flex-direction: column;
      padding: 30px 20px;
      gap: 40px;
      .address {
        width: 100%;
      }
    }
  }

  @media (max-width: 1920px) {
    margin-top: -60px;
  }

  @media (max-width: 1450px) {
    margin-top: -70px;
  }

  @media (max-width: 1200px) {
    margin-top: -80px;
  }

  @media (max-width: 767px) {
    margin-top: 0px;
    padding-left: 0;
    margin-left: 0;
  }
`;
export default BannerAddress;
